import { pay } from '@/api/payment'

const payment = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 登录
    paymentPay({ commit }, payload) {
      return new Promise((resolve, reject) => {
        pay(payload.item, payload.provider).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default payment
